<script lang="ts" setup="">
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  date: Date | string | number | null | undefined
  icon?: boolean
}>()

const site = useSiteConfig()
</script>

<template>
  <div v-if="date" class="flex items-center gap-3 p-1">
    <!-- FIXME: Fall back to generated published date if component is not populated -->
    <Icon v-if="icon" :icon="faCalendarDays" />
    <span>
      Publisert
      <NuxtTime
        itemprop="datePublished"
        :datetime="date"
        :locale="site.defaultLocale"
        day="2-digit"
        month="long"
        year="numeric"
      />
    </span>
  </div>
</template>
